module.exports = __webpack_public_path__ + "7d9e367412a7bf75ddc6b912d572a54d.pdf";